import { Grid } from "@mui/material";
import StepperWrapper from './Stepper';
import Pager from './Pager';
import { useSelector } from 'react-redux';
import { cancelBooking, currentPage } from "../../features/BookingsSlice";
import { useEffect } from 'react';

export const enum PAGES {
  CreateBooking= 0,
  UploadSupportingDocs= 1,
  Confirmation= 2,
};

function CreateBookingWrapper() {
  const pageState = useSelector(currentPage);

  useEffect(() => {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }, []);

  return (
    <Grid container sx={{ height: 1, display: "block" }}>
      <div style={{display: 'flex', justifyContent: 'flex-start', borderBottom: '1px solid #E1E1E1', width: "100%", marginBottom: "22px"}} role="heading" aria-level={2}>
        <h1 style={{fontSize: "32px", color: "#00558B", marginTop: 0, fontWeight: "normal"}}>Create Booking</h1>
      </div>
      <div style={{paddingBottom: "22px"}} role="region"><StepperWrapper page={pageState}/></div>
      <main style={{ maxWidth: "1500px", height: 1, display: "initial" }}>
        <Pager page={pageState} cancel={cancelBooking}/>
      </main>
    </Grid>
  );
}

export default CreateBookingWrapper;
